export class UserSubscription {
  constructor(
    public isSubscribed: boolean = false,
    public isBusiness: boolean = false,
    public isAdmin: boolean = false,
    public isEditor: boolean = false,
    public name: string = ''
  ){}
}
